import React from "react";
import { Card, Col, Row, Dropdown, Nav } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { FiCalendar, FiMoreVertical } from "react-icons/fi";

const getStatusModifier = (status) => {
  if (status === "successful") return "user-booking-card__status--success";
  if (status === "pending") return "user-booking-card__status--pending";
  return "user-booking-card__status--failed";
};

const formatStatusLabel = (status) => {
  if (!status) return "Unknown";
  return status.charAt(0).toUpperCase() + status.slice(1);
};

const UserBookingCard = ({ item, tab, onReview, onCancel }) => {
  const event = item?.bmtEvent;
  const title = event?.title || "Adventure";
  const eventDate = item?.eventDate?.startDate;
  const endDate = item?.eventDate?.endDate;
  const canReview =
    tab === "complete" &&
    item.bookingStatus === "successful" &&
    endDate &&
    moment(endDate).diff(moment(), "days") <= 0;
  const canCancel = tab === "upcoming" && item.bookingStatus === "successful";

  const detailLink = {
    pathname: `/bookingdetails/${item.id}`,
    bookinglist: item,
  };

  return (
    <Col xs={12} lg={6} className="margin-btm">
      <Card className="user-booking-card">
        <Row className="g-0">
          <Col xs={4} md={4} className="user-booking-card__media-col">
            <Link to={detailLink} className="user-booking-card__image-link">
              <Card.Img
                src={event?.banner}
                alt={title}
                className="user-booking-card__image"
              />
            </Link>
          </Col>
          <Col xs={8} md={8} className="user-booking-card__body-col">
            <div className="user-booking-card__body">
              <div className="user-booking-card__header">
                <Link to={detailLink} className="user-booking-card__title-link">
                  <h3 className="user-booking-card__title">{title}</h3>
                </Link>
                {(canReview || canCancel) && (
                  <Dropdown align="end" className="user-booking-card__menu">
                    <Dropdown.Toggle
                      variant="link"
                      className="user-booking-card__menu-toggle"
                      id={`booking-menu-${item.id}`}
                    >
                      <FiMoreVertical aria-hidden="true" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {canReview && (
                        <Dropdown.Item onClick={() => onReview(item)}>
                          Write a review
                        </Dropdown.Item>
                      )}
                      {canCancel && (
                        <Dropdown.Item
                          className="text-danger"
                          onClick={() => onCancel(item)}
                        >
                          Cancel booking
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>

              <Link to={detailLink} className="user-booking-card__details-link">
                <p className="user-booking-card__meta">
                  Booking ID: <strong>#{item.id}</strong>
                </p>
                <p className="user-booking-card__amount">₹{item.totalAmount}</p>
                <p className="user-booking-card__meta">
                  Booked on {moment(item.createdOn).format("DD MMM YYYY")}
                </p>
                {eventDate && (
                  <p className="user-booking-card__meta user-booking-card__event-date">
                    <FiCalendar aria-hidden="true" />
                    <span>
                      Event date: {moment(eventDate).format("DD MMM YYYY")}
                    </span>
                  </p>
                )}
              </Link>

              <span
                className={`user-booking-card__status ${getStatusModifier(
                  item.bookingStatus
                )}`}
              >
                {formatStatusLabel(item.bookingStatus)}
              </span>
            </div>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default UserBookingCard;
